import { MigrationManifest, PersistedState } from 'redux-persist';

const migrations: MigrationManifest = {
  3: (state: PersistedState) => {
    return {};
  },
};

export default migrations;
